/**
 * Vidarebefordran av inkommande supportärenden till en extra brevlåda.
 * Gäller bara ärenden på just denna organisation, och bara när det är aktiverat.
 */

import React from 'react';
import { useTranslation } from '@/store/languageStore';

interface Props {
  enabled: boolean;
  email: string;
  isPartner?: boolean;
  onChange: (next: { support_forward_enabled: boolean; support_forward_email: string }) => void;
}

const OrganizationSupportForwardSettings: React.FC<Props> = ({ enabled, email, isPartner = false, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="p-4 rounded-lg border border-border bg-bgElevated space-y-4">
      <div>
        <h3 className="text-sm font-medium text-textDefault">{t('organizations.supportForward.title')}</h3>
        <p className="text-xs text-textSecondary mt-1">
          {t(isPartner ? 'organizations.supportForward.partnerIntro' : 'organizations.supportForward.intro')}
        </p>
      </div>

      <label className="flex items-start gap-2 text-sm text-textDefault">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onChange({ support_forward_enabled: e.target.checked, support_forward_email: email })}
          className="mt-0.5 w-4 h-4 border border-border rounded bg-bgElevated text-primary focus:ring-primary"
        />
        <span>
          <span className="font-medium">{t('organizations.supportForward.enabled')}</span>
          <span className="block text-xs text-textSecondary mt-0.5">{t('organizations.supportForward.enabledHelp')}</span>
        </span>
      </label>

      <div>
        <label className="block text-sm font-medium text-textDefault mb-1" htmlFor="support-forward-email">
          {t('organizations.supportForward.email')}
        </label>
        <input
          id="support-forward-email"
          type="email"
          value={email}
          onChange={(e) => onChange({ support_forward_enabled: enabled, support_forward_email: e.target.value })}
          placeholder={t('organizations.supportForward.emailPlaceholder')}
          className="w-full max-w-md px-3 py-2 border border-border rounded-lg bg-bgContainer text-textDefault"
        />
        <p className="text-xs text-textSecondary mt-1">
          {t(isPartner ? 'organizations.supportForward.partnerEmailHelp' : 'organizations.supportForward.emailHelp')}
        </p>
      </div>
    </div>
  );
};

export default OrganizationSupportForwardSettings;
